/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { UserLayout } from "../components/UserManagement/UserLayout";
import { PermissionTab } from "../components/UserManagement/RoleManagement/PermissionTab";
import PageTabs from "../../../components/Common/PageTabs";
import { ContentLayout } from "../../../components/Common";

/**
 * This page is used for editing PACE users.
 * This page deals with syncing users to PACE and editing them and their permissions.
 */
const UserManagementPage = () => {
	const tabs = [
		{
			label: "User Management",
			id: "user_management",
			component: <UserLayout />,
			default: true,
		},
		{
			label: "Roles",
			id: "roles",
			component: <PermissionTab />,
			default: false,
		},
	];

	return (
		<ContentLayout>
			<PageTabs tabs={tabs} requireConfirmOnChange selectedTabInQueryString={true} />
		</ContentLayout>
	);
};

export default UserManagementPage;
